import { render, staticRenderFns } from "./OtherobjectPassport.vue?vue&type=template&id=6bba3dca&scoped=true"
import script from "./OtherobjectPassport.vue?vue&type=script&lang=js"
export * from "./OtherobjectPassport.vue?vue&type=script&lang=js"
import style0 from "./OtherobjectPassport.vue?vue&type=style&index=0&id=6bba3dca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bba3dca",
  null
  
)

export default component.exports